import Instance from '../../../Axios';

const RemoverCategoria = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .delete(`/backend/categorias/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'DELETE_CATEGORIA', payload: data });
    })
    .catch(({ err }) => console.log(err));
};

export default RemoverCategoria;
